import React from 'react';

export default ({ size = 16, color = '#000' }) => (
  <svg
    height={size}
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1024 1024"
  >
    <path
      style={{
        transform: 'scale(0.75) rotate(45deg)',
        transformOrigin: 'center',
      }}
      fill={color}
      d="M960.001 0q27.5 0 45.75 18.251t18.251 45.75q0 27-18.5 45.5l-403.001 402.5 403.001 402.5q18.5 18.5 18.5 45.5 0 27.5-18.251 45.75t-45.75 18.251q-27 0-45.5-18.5l-402.5-403.001-402.5 403.001q-18.5 18.5-45.5 18.5-27.5 0-45.75-18.251t-18.251-45.75q0-27 18.5-45.5l403.001-402.5-403.001-402.5q-18.5-18.5-18.5-45.5 0-27.5 18.251-45.75t45.75-18.251q27 0 45.5 18.5l402.5 403.001 402.5-403.001q18.5-18.5 45.5-18.5z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/icons/Plus.js